<template>
  <div class="chart-container">
    <div class="chart-header">
      <border-box :message="title"></border-box>
      <div class="unit">
      </div>
    </div>
    <div :style="chartStyle" id="left_middle2_chart2">
    </div>
  </div>
</template>

<script>
  //import { selectYear, selectFunctionalAnalysis} from '@/api/dataview/functionAlanalysis'
  import BorderBox from '../border/BorderBox'
  var echartsMap
  export default {
    name: 'AppFunction',
    components: { BorderBox },
    props: ['title', 'unit'],
    data () {
      return {
        chartStyle: { width: '100%', height: 'calc(97%)' },
        yearList: [],
        chosedOptinOne: ''
      }
    },
    mounted () {
      //var that = this
      var param = {}
      param.type = 'dashboard-year'
      // 当前用户累计总数

          this.init()

    },
    methods: {
      selectYearData () {
        var that = this
        // console.log(that.chosedOptinOne)
        that.init()
      },
      init () {
        var that = this
        echartsMap = that.$echarts.init(document.getElementById('left_middle2_chart2'))
        var option = {

          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}'
          },
          xAxis: {
            type: 'category',
            name: 'x',
            axisLabel: {
              show: true,
              textStyle: {
                color: '#88e3ff'
              }
            },

            axisLine: {
              show: true,
              lineStyle: {
                color: '#88e3ff',
                width: 1
              }
            },
            splitLine: { show: false },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月']
          },
          grid: {
            top:'8%',
            left: '2%',
            right: '2%',
            bottom: '9%',
            containLabel: true
          },
          yAxis: {
            type: 'value',
            name: 'y',
            minorSplitLine: {
              show: false
            },
            splitLine: {show: false},
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff',
                width: 2
              }
            },
          },
          series: [
            {
              name: 'Log2',
              type: 'line',
              data: [1,81, 247, 741, 3, 9, 27,  223, 669]
            },
            {
              name: 'Log3',
              type: 'line',
              data: [1, 64, 128, 256, 2, 4, 8, 16, 32]
            },

          ]
        };
            echartsMap.setOption(option)

            window.addEventListener("resize", function() {
              echartsMap.resize();
            });
          }

    }
  }
</script>

<style lang="stylus" scoped>
  .chart-container
    display flex
    flex-direction column
    // border 1px solid rgba(14, 101, 187, 0.66);
    height calc(100%)
    .chart-header
      display flex
      // border-box
      //   flex-grow auto
      justify-content space-between
      .unit
        width 60px
        margin-right 8px
        line-height 30px
        font-size 15px
        font-family Microsoft YaHei
        font-weight 400
        color white

</style>
